import { render, staticRenderFns } from "./VendorShow.vue?vue&type=template&id=512e7e5c&"
import script from "./VendorShow.vue?vue&type=script&lang=js&"
export * from "./VendorShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports